import { AppEnv, EnvProps } from './index';
import { prodEnvDefaults } from './env-defaults';
import { prodMigratedLinks, prodMigratedTx } from './react-migration';

const env: EnvProps = {
  ...prodEnvDefaults,
  appEnv: AppEnv.PROD,
  ebisCoreServiceUrl: 'https://ebis.mlb.com/ebis2-core-services',
  ebisGlobalServiceUrl: 'https://ebis.mlb.com/ebis2-global-services',
  ebisClubServiceUrl: 'https://ebis.mlb.com/ebis2-club-services',
  ebisAdvSearchServiceUrl: 'https://ebis.mlb.com/ebis2-advsearch-services',
  ebisReportServiceUrl: 'https://ebis.mlb.com/ebis2-reports-services',
  eventBusUrl: 'https://ebis.mlb.com/eventbus',
  cepServiceUrl: 'https://ebis2-cep-api.mlbinfra.com/ebis2-cep-services',
  ebisRule4ServiceUrl: 'https://ebis.mlb.com/ebis2-rule4-services',
  reactMigration: {
    migratedLinks: prodMigratedLinks,
  },
  migratedTx: prodMigratedTx,
};

window.MLBBest = { env };
